export default __webpack_public_path__ + "static/media/adapting_assistive_technologies_NVDA_JAWS.5265f59b.svg";